import {DescriptionText, H1Text, H2Text} from "../../../../../design";
import {AmountDivideByHundred} from "../../../../../helper";
import React from "react";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyFormatter from "../../../../../utils/currencyformatter";

type Props = {
  invoice: Object,
}

const InvoicePayHeader = (props:Props) => {
  const {invoice } = props;
  return (
    <SmallScreenHeader>
      <H1Text>
        PAY INVOICE
      </H1Text>
      <H2Text>
        Payment For
      </H2Text>
      <DescriptionText>
        {invoice && invoice.description}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {invoice && invoice.currency && invoice.total && currencyFormatter(AmountDivideByHundred(invoice && invoice.total), invoice.currency.name)}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default InvoicePayHeader
